import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../storage.service';

@Injectable()
export class MSALAuthGuard {

  constructor(public router: Router,
    private storageService: StorageService) { }

  canActivate(): boolean {
    let storedToken = (this.storageService.getSessionStorage('msal.idtoken') && this.storageService.getCookie('msal.idTokenExpiry')) ?
      this.storageService.getSessionStorage('msal.idtoken') : '';
    if (!storedToken) {
      return false;
    }
    return true;
  }
}

export const MSALAuthGuardService: CanActivateFn = () => {
  return inject(MSALAuthGuard).canActivate();
}